import React from 'react'
import styles from './BulkPost.pcss'
import { DebouncedTextField } from 'components/DebouncedTextField'
import { useIntl } from 'react-intl'
import { TIKTOK_PHOTO_TITLE_MAX_LENGTH, TIKTOK_PHOTO_DESCRIPTION_MAX_LENGTH } from 'shared/constants'

interface TikTokPostStatusProps {
  videoCaption: string
  photoTitle: string
  photoDescription: string
  isPhotoPost: boolean
  onCaptionChange: (text: string) => void
  onPhotoStatusChange: (data: { title?: string, description?: string }) => void
}

export function TikTokPostStatus({
  videoCaption,
  photoTitle,
  photoDescription,
  isPhotoPost,
  onCaptionChange,
  onPhotoStatusChange
}: TikTokPostStatusProps) {
  const intl = useIntl()

  const onTitleChange = (text: string) => {
    onPhotoStatusChange({ title: text })
  }
  const onDescriptionChange = (text: string) => {
    onPhotoStatusChange({ description: text })
  }

  return (
    <div className={styles.pin}>
      {isPhotoPost ? (
        <React.Fragment>
          <div className={styles['pin-input-row']}>
            <DebouncedTextField
              value={photoTitle}
              multiline
              maxLength={TIKTOK_PHOTO_TITLE_MAX_LENGTH}
              placeholder={intl.formatMessage({ id: 'composer.labels.tiktok-title-placeholder' })}
              className={styles['title-box']}
              FormHelperTextProps={{ className: styles.helper }}
              onTextChange={onTitleChange}
            />
            {/* <span className={styles['txt-btn']}></span> */}
          </div>
          <div className={styles['pin-input-row']}>
            <DebouncedTextField
              value={photoDescription}
              multiline
              maxLength={TIKTOK_PHOTO_DESCRIPTION_MAX_LENGTH}
              placeholder={intl.formatMessage({ id: 'composer.labels.tiktok-text-placeholder' })}
              className={styles['description-box']}
              FormHelperTextProps={{ className: styles.helper }}
              InputProps={{
                classes: {
                  root: styles['description-input']
                }
              }}
              onTextChange={onDescriptionChange}
            />

            {/* <span className={styles['txt-btn']}></span> */}
            {/* <span role="button" className={styles['txt-btn']} onClick={applyPinUrlToAll}>
              <FormattedMessage id="actions.copy-to-all" />
            </span> */}
          </div>
        </React.Fragment>
      ) : (
        <div className={styles['pin-input-row']}>
          <DebouncedTextField
            value={videoCaption}
            multiline
            placeholder={intl.formatMessage({ id: 'composer.multi-post.placeholders.status' })}
            classes={{ root: `${styles['caption-box']} ${styles['title-box']}` }}
            FormHelperTextProps={{ className: styles.helper }}
            onTextChange={onCaptionChange}
          />
          {/* <span role="button" className={styles['txt-btn']} onClick={applyPinTitleToAll}>
            <FormattedMessage id="actions.copy-to-all" />
          </span> */}
        </div>
      )}
    </div>
  )
}
